export class Context {
  public static readonly KEY_CLIENT_NAME = 'client_name';
  public static readonly KEY_USER_NAME = 'username';
  public static readonly KEY_SO_PAGE_INDEX = 'scenario_overview_page_index';
  public static readonly KEY_SO_PAGE_SIZE = 'scenario_overview_page_size';
  public static readonly KEY_SO_SORT_KEY = 'scenario_overview_sort_key';
  public static readonly KEY_SO_SORT_ORDER = 'scenario_overview_sort_order';
  public static readonly KEY_SO_SEARCH_TERM = 'scenario_overview_search_term';
  public static readonly KEY_SCENARIO_NAME = 'scenario_name';
  public static readonly KEY_SELECTED_DATE = 'date';
  public static readonly KEY_SELECTED_LINK_TYPE = 'selected_link_type';
  public static readonly KEY_CURRENT_SCENARIO_ID = 'current_scenario_id';
  public static readonly KEY_CURRENT_EQUIPMENT_ID = 'current_equipment_id';
  public static readonly KEY_METERING_LOCATION = 'current_metering_location';
  public static readonly KEY_CURRENT_CLIENT_ID = 'current_client_id';
  public static readonly KEY_CLIENT_COUNT = 'client_count';
  public static readonly KEY_CURRENT_CLIENT_NAME = 'current_client_name';
  public static readonly KEY_CURRENT_USER_NAME = 'current_user_name';
  public static readonly KEY_SELECTED_STOCK_NAME = 'selected_stock_name';
  public static readonly KEY_STOCK_LIST_SEARCH_NAME = 'stock_list_search_name';
  public static readonly KEY_STOCK_LIST_SEARCH_STOCK_TYPE = 'stock_list_search_stock_type';
  public static readonly KEY_STOCK_LIST_SEARCH_ADDRESS = 'stock_list_search_address';
  public static readonly KEY_TOKEN = 'id_token';
}
